document.addEventListener('DOMContentLoaded', () => {
    const productCards = document.querySelectorAll('.byob-product-col');
    const countEl = document.getElementById('byob-selected-count');
    const progressEl = document.getElementById('byob-progress');
    const addBtn = document.getElementById('byob-add-to-cart');
    const comparePriceEl = document.getElementById('byob-compare-price');
    const finalPriceEl = document.getElementById('byob-final-price');
    const selectedImageBoxes = document.querySelectorAll('.byob-selected-image');
    const bundleTabs = document.querySelectorAll('.byob-bundle-tab');
    const imageContainer = document.querySelector('.byob-selection-image');
    let selectedVariants = [];

    const activeTab = document.querySelector('.byob-bundle-tab.active');
    let currentBundleCount = Number(activeTab.dataset.count);
    let currentBundlePrice = Number(activeTab.dataset.price);

    function formatPrice(price) {
        return '₹' + Number(price).toLocaleString('en-IN');
    }

    function resetSelections() {
        selectedVariants = [];
        productCards.forEach(card => {
            card.classList.remove(
                'is-selected'
            );
        });
        updateUI();
    }

    function updateSelectedImages() {
        selectedImageBoxes.forEach(
            (box, index) => {
                box.innerHTML = '';
                if (
                    index <
                    currentBundleCount
                ) {
                    box.style.display = 'flex';
                } else {
                    box.style.display = 'none';
                }
            }
        );

        selectedVariants.forEach(
            (product, index) => {
                if (
                    selectedImageBoxes[index]
                ) {
                    selectedImageBoxes[index].innerHTML = `
                        <img src="${product.image}" alt="">
                    `;
                }
            }
        );

        if (currentBundleCount >= 6) {
            imageContainer.classList.add('compact');
        } else {
            imageContainer.classList.remove('compact');
        }
    }

    function updatePrices() {
        let totalComparePrice = 0;
        selectedVariants.forEach(product => {
            totalComparePrice += Number(product.comparePrice || 0);
        });

        const comparePrice = totalComparePrice / 100;
        let finalPrice = comparePrice;

        if (selectedVariants.length === currentBundleCount) {
            finalPrice = currentBundlePrice;
        }

        comparePriceEl.innerHTML = `
            <span style="text-decoration:line-through;">
                ${formatPrice(comparePrice)}
            </span>
        `;

        finalPriceEl.innerHTML = `
            <span>
                ${formatPrice(finalPrice)}
            </span>
        `;
    }

    function updateUI() {
        countEl.textContent = selectedVariants.length;
        progressEl.style.width = ((selectedVariants.length / currentBundleCount) * 100) + '%';

        addBtn.disabled = selectedVariants.length !== currentBundleCount;

        document.querySelector( '.byob-selection-status').innerHTML = `
            <span id="byob-selected-count">
                ${selectedVariants.length}
            </span>
            /${currentBundleCount}
            Selected
        `;
        updateSelectedImages();
        updatePrices();
    }

    bundleTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            bundleTabs.forEach(btn => btn.classList.remove('active'));

            tab.classList.add('active');

            currentBundleCount = Number(tab.dataset.count);
            currentBundlePrice = Number(tab.dataset.price);
                resetSelections();
            }
        );
    });

    productCards.forEach(card => {
        card.addEventListener('click', () => {
            const variantId = card.dataset.variantId;
            const image = card.dataset.image;
            const price = Number(card.dataset.price);
            const comparePrice = Number(card.dataset.comparePrice);
            if (!variantId){
                alert(
                    'Variant ID Missing'
                );
                return;
            }
            if (card.classList.contains('is-selected')) {
                card.classList.remove(
                    'is-selected'
                );
                selectedVariants = selectedVariants.filter(item => item.id !== variantId);
                } else {
                    if (selectedVariants.length >= currentBundleCount) {
                        alert(`You can select only ${currentBundleCount} products`);
                        return;
                    }

                    card.classList.add( 'is-selected');
                    selectedVariants.push({
                        id: variantId,
                        image,
                        price,
                        comparePrice
                    });

                    if (selectedVariants.length === currentBundleCount) {
                        confetti({
                            particleCount: 150,
                            angle: 60,
                            spread: 80,
                            origin: {x: 0, y: 0.7}
                        });
                        confetti({
                            particleCount: 150,
                            angle: 120,
                            spread: 80,
                            origin: {x: 1, y: 0.7}

                        });
                    }
                }
                updateUI();
            }
        );
    });

    addBtn.addEventListener('click', async () => {
        if (selectedVariants.length !== currentBundleCount) {
            alert(`Please select ${currentBundleCount} products`);
            return;
        }

        try {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Adding Products...';

            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            
            if (cartData.items && cartData.items.length > 0) {
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });

                await new Promise( resolve => setTimeout(resolve, 1000));
            }

            const items = selectedVariants.map(item => ({
                id: Number(item.id),
                quantity: 1
            }));

            const response = await fetch( '/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({items})
            });

            if (!response.ok) {
                throw new Error('Add To Cart Failed');
            }

            addBtn.innerHTML = 'Redirecting...';

            window.location.href = '/cart';

            } catch (error) {
                console.error(error);
                alert( 'Something went wrong');

                addBtn.disabled = false;
                addBtn.innerHTML = 'Add to Cart';
            }
        }
    );
    updateUI();
});